// extracted by mini-css-extract-plugin
export default {"Loading":"Loading_Loading__CVYFJ","spinner":"Loading_spinner__JWaO+"};